import { createSlice } from '@reduxjs/toolkit';

export const slice = createSlice({
    initialState: {
        blockedNavigation: false as boolean,
        blockedPath: undefined as string | undefined,
        isBlocked: false as boolean,
        unblockedNavigation: false as boolean
    },

    name: 'useNavigation',

    reducers: {
        blockedNavigation: (state, action) => {
            state.blockedNavigation = action.payload;
        },

        blockedPath: (state, action) => {
            state.blockedPath = action.payload;
        },

        isBlocked: (state, action) => {
            state.isBlocked = action.payload;
        },

        unblockedNavigation: (state, action) => {
            state.unblockedNavigation = action.payload;
        }
    }
});

export default slice.reducer;
